/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Stack,
  Link,
  Toolbar,
  Typography,
  Container,
  AppBar,
  Button,
  Drawer,
  Box,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import HoverImage from 'react-hover-image';
import { MenuOptions, MenuOptionsChn } from 'assets/web-contents/MenuItems';
// Wimss context
import {
  useWimssController,
  setCurrentLanguage,
  setCurrentPage,
  setCurrentTexts,
  setCurrentTab,
} from 'context';

import TopBannerEng from 'assets/images/logos/Top-banner-logo.png';
import TopBannerChn from 'assets/images/logos/Top-banner-logo-chn.png';
import { initTexts } from 'utils/syncState';

function ResponsiveHeader() {
  const [controller, dispatch] = useWimssController();
  const { currentLanguage, currentPage } = controller;

  // const [language, setLanguage] = useState('');
  const [selectedMenuOpt, setSelectedMenuOpt] = useState(MenuOptions);
  // let state = JSON.parse(localStorage.getItem('state'));
  const navigate = useNavigate();

  useEffect(() => {
    if (currentLanguage !== null && currentPage !== null) {
      const txts = initTexts(currentLanguage, currentPage);
      setCurrentTexts(dispatch, txts);
      navigate('/' + currentPage);
    }
  }, [currentLanguage, currentPage]);

  const onLanguageChange = () => {
    if (currentLanguage === 'English') {
      setCurrentLanguage(dispatch, 'Chinese');
      setSelectedMenuOpt(MenuOptionsChn);
    }
    if (currentLanguage === 'Chinese') {
      setCurrentLanguage(dispatch, 'English');
      setSelectedMenuOpt(MenuOptions);
    }
  };

  const onPageChange = (page) => {
    const pg = page.substring(1);
    setCurrentPage(dispatch, pg);
    // const txts = initTexts(currentLanguage, pg);
    // setCurrentTexts(dispatch, txts);
    setCurrentTab(dispatch, 0);
  };

  const Nav = () => {
    const [open, setOpen] = useState(false);
    const toggleDrawer = (newOpen) => () => {
      setOpen(newOpen);
    };
    return (
      <>
        <Button
          variant='text'
          onClick={toggleDrawer(true)}
          sx={{
            color: 'Blue',
            display: { xs: 'block', xl: 'none' },
          }}>
          <MenuIcon />
        </Button>
        <Drawer
          open={open}
          onClose={toggleDrawer(false)}
          anchor='right'
          sx={{
            display: { xs: 'inherit', xl: 'none' },
            '& .MuiDrawer-paper': {
              height: '100vh',
              // width: '100%',
            },
          }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              p: 2,
            }}>
            <Button onClick={toggleDrawer(false)}>
              <CloseIcon />
            </Button>
          </Box>
          <NavList />
        </Drawer>
        {selectedMenuOpt && (
          <NavList
            sx={{
              display: {
                xs: 'none',
                xl: 'inherit',
              },
            }}
          />
        )}
      </>
    );
  };

  const NavList = ({ ...props }) => {
    return (
      <Stack
        overflow='auto'
        direction={{ xl: 'row' }}
        gap={2}
        justifyContent='flex-end'
        {...props}
        // width={{ xs: '100%', sm: 'initial' }}
        // textAlign={{ xs: 'center', sm: 'initial' }}
        // fontSize={{ xs: '22px', sm: 'initial' }}
      >
        {selectedMenuOpt.map((page) => (
          // <Link
          //   key={page.path}
          //   sx={{
          //     color: { xs: 'primary', sm: 'white' },
          //     textDecoration: 'none',
          //   }}>
          //   {page.name}
          // </Link>
          <HoverImage
            key={page.path}
            src={page.src}
            hoverSrc={page.srcHovered}
            onClick={() => onPageChange(page.path)}
            style={{
              width: '150px',
              // '& img:focus': {
              //   backgroundImage:
              //     'linear-gradient(to bottom, rgb(255,255,255,0),rgb(255,233,153,0.6))',
              // },
            }}
          />
        ))}
        {currentLanguage === 'English' ? (
          <Button variant='contained' onClick={() => onLanguageChange()}>
            中文
          </Button>
        ) : (
          <Button variant='contained' onClick={() => onLanguageChange()}>
            Eng
          </Button>
        )}
      </Stack>
    );
  };

  return (
    <AppBar position='sticky' sx={{ p: 0, m: 0, backgroundColor: '#FFFFFF' }}>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        width='100%'
        sx={{ p: 0, m: 0 }}>
        <img
          src={currentLanguage === 'English' ? TopBannerEng : TopBannerChn}
          alt='Wimss Logo'
          height='120px'
        />

        {currentLanguage && <Nav />}
      </Stack>
    </AppBar>
  );
}
export default ResponsiveHeader;
